import React from 'react';
import { useSelector } from 'react-redux';
import {
  IconAndroidFill,
  IconIosFill,
} from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import {
  constants as appStorageConstants,
  records as appStorageRecords,
} from '@saucelabs/sl-module-app-storage';

import { selectors as testConfigSelectors } from '../../testConfiguration';
import { utils } from '../';
import { GlobalState } from '../../../reducers';
import FileIcon from './FileIcon';

const { APP_STORAGE_KIND } = appStorageConstants;

const SelectedStateIcons: React.FC = () => {
  const mobileAppConfiguration = useSelector<GlobalState, appStorageRecords.AppStorageFile | null>(
    testConfigSelectors.mobileAppConfigurationSelector,
  );

  if (!mobileAppConfiguration) {
    return null;
  }

  const appKind = mobileAppConfiguration.kind;

  return (
    <>
      {/* app icon */}
      {mobileAppConfiguration && (
        <FileIcon
          alt="App icon."
          className="h-3 w-3 ml-1"
          file={mobileAppConfiguration}
        />
      )}
      {/* platform icon */}
      {appKind === APP_STORAGE_KIND.ANDROID ?
        <IconAndroidFill className="inline-block h-2 w-2 ml-1 text-medium-emphasis fill-current" /> :
        <IconIosFill className="inline-block h-2 w-2 ml-1 text-medium-emphasis fill-current" />}
    </>
  );
};

const SelectedStateVersions: React.FC = () => {
  const mobileAppConfiguration = useSelector<GlobalState, appStorageRecords.AppStorageFile | null>(
    testConfigSelectors.mobileAppConfigurationSelector,
  );

  if (!mobileAppConfiguration) {
    return null;
  }

  return (
    <Typography
      className="text-medium-emphasis truncate"
      component="span"
    >
      {`(${utils.buildAppVersionString(mobileAppConfiguration)})`}
    </Typography>
  );
};

export {
  SelectedStateIcons,
  SelectedStateVersions,
};
